"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = FPCTPageTwo;
var _react = _interopRequireDefault(require("react"));
var _formik = require("formik");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/* eslint-disable no-unused-vars */

function FPCTPageTwo() {
  var {
    errors,
    touched,
    values,
    setFieldValue
  } = (0, _formik.useFormikContext)();
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "Welcome to Page 2!");
}